module.exports = __webpack_public_path__ + "static/media/ET069 new.d59965b4.jpg";